<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs3>
          <v-toolbar-title>Notification</v-toolbar-title>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="text-right" xs3>
          <v-btn to="/notification/add" dark color="indigo">
            <v-icon dark>add_circle</v-icon>New
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="body"
        :search="search"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">delete</v-icon>
          <v-icon v-if="item.canApprove" small @click="approveItem(item)">send</v-icon>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true">No results found.</v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import commonservice from "../../shared/common.service"
export default {
  data() {
    return {
      search: "",
      loading: false,
      options: {},
      total: 0,
      headers: [
        { text: "NotificationType", value: "notificationType" },
        { text: "Title", value: "title" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "action", sortable: false }
      ],
      body: []
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search() {
      this.getData();
    }
  },
  methods: {
    editItem(item) {
      this.$router.push("/notification/edit/" + item.id);
    },
    deleteItem(item) {
      var title = "Are you sure, you want to delete notification?";
      commonservice.showDialog("Delete","Are you sure, you want to delete notification?")
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("notification/deleteNotification", { id: item.id })
              .then(() => {
                this.getData();
                commonservice.showSuccessMessage("Notification deleted successfully")
              });
          }
        });
    },
    approveItem(item) {
      commonservice.showDialog("Approve","Are you sure, you want to send this notification?")
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("notification/approveNotification", { id: item.id })
              .then(() => {
                this.getData();
                commonservice.showSuccessMessage("Notification send successfully")
              });
          }
        });
    },
    getData() {
      this.$store
        .dispatch("notification/loadNotification", {
          pagination: this.options,
          search: this.search
        })
        .then(response => {
          this.loading = false;
          this.body = response.data.data;
          this.total = response.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
